import type { Permiso } from "../../shared/types";
import type { NombreIcono } from "../components/Icono";

// Registro central de módulos del sidebar. Agregar un módulo futuro (tareas,
// facturación, CRM, etc.) implica solo sumar una entrada acá + su ruta en
// App.tsx — el Sidebar y el AppLayout no necesitan modificarse.
export interface DefinicionModulo {
  clave: string;
  etiqueta: string;
  ruta: string;
  icono: NombreIcono; // ver src/components/Icono.tsx — set propio, sin dependencia de librerías externas
  permisosRequeridos?: Permiso[]; // OR: alcanza con tener uno cualquiera. Si es undefined, visible para todos los roles autenticados.
}

export const MODULOS: DefinicionModulo[] = [
  { clave: "dashboard", etiqueta: "Paneles Ejecutivos", ruta: "/dashboard", icono: "dashboard" },
  { clave: "mi-trabajo", etiqueta: "Mi Trabajo", ruta: "/mi-trabajo", icono: "actuaciones" },
  {
    clave: "expedientes",
    etiqueta: "Expedientes",
    ruta: "/expedientes",
    icono: "expedientes",
    permisosRequeridos: ["expedientes.ver_todos", "expedientes.ver_asignados"],
  },
  {
    clave: "clientes",
    etiqueta: "Clientes",
    ruta: "/clientes",
    icono: "clientes",
    permisosRequeridos: ["clientes.ver"],
  },
  {
    clave: "actuaciones",
    etiqueta: "Actuaciones",
    ruta: "/actuaciones",
    icono: "actuaciones",
    permisosRequeridos: ["actuaciones.ver"],
  },
  {
    clave: "agenda",
    etiqueta: "Agenda",
    ruta: "/agenda",
    icono: "agenda",
    permisosRequeridos: ["agenda.ver"],
  },
  {
    clave: "documentos",
    etiqueta: "Buscar documentos",
    ruta: "/documentos",
    icono: "documentos",
    permisosRequeridos: ["documentos.ver"],
  },
  {
    clave: "economia",
    etiqueta: "Economía",
    ruta: "/economia",
    icono: "economia",
    permisosRequeridos: ["economia.ver"],
  },
  {
    clave: "procesos",
    etiqueta: "Procesos de Trabajo",
    ruta: "/procesos",
    icono: "kanban",
    permisosRequeridos: ["procesos.ver"],
  },
  {
    clave: "usuarios",
    etiqueta: "Usuarios",
    ruta: "/usuarios",
    icono: "usuarios",
    permisosRequeridos: ["usuarios.ver"],
  },
  {
    clave: "configuracion",
    etiqueta: "Configuración",
    ruta: "/configuracion",
    icono: "configuracion",
    permisosRequeridos: ["configuracion.ver"],
  },
];
